// Instance
import MainAPI from '@/app/apis/main/main-api.js';

// Endpoints
import { API, ENDPOINTS } from '@/app/apis/main/_connection/connection-api.js';

class suppliersAPI extends MainAPI {
    /**
     * @param queryParams
     * @return {object} Suppliers List
     * */
    async getSuppliersList() {
        return API.get(`${ENDPOINTS.GET_SUPPLIERS_LIST}`);
    }

}

export default new suppliersAPI();